import React, {Component} from "react";
import Cookies from "universal-cookie";
import {Buffer} from "buffer";
import {offerGeneralApiService} from "../../services/offer/OfferGeneralApiService";
import {Button, Card, Col, Divider, Input, Modal, Row, Select, Spin, Tooltip} from "antd";
import CurrencyInput from "react-currency-input-field";
import currencyFormat from "../../helper/currencyFormat";
import BankSelect from "../bank/BankSelect";
import VehicleBrandSelect from "../vehicle/VehicleBrandSelect";
import VehicleModelSelect from "../vehicle/VehicleModelSelect";
import SelectLeasing from "../selects/SelectLeasing";
import {InfoCircleOutlined} from "@ant-design/icons";

class UpdateGeneralOffer extends Component<any, any> {
    private readonly initState!: any;
    private user = JSON.parse(Buffer.from(new Cookies().get('_u'), "base64").toString())

    constructor(props: any) {
        super(props);
        this.initState = {
            fetchingDetailOffer: false,
            offerStatus: "",
            offerCode: "",

            transactionType: null,
            documentOwnershipType: null,

            customerBankCode: null,
            customerBankName: null,
            customerBankShortName: null,
            customerBankAccountNumber: null,
            customerBankAccountName: null,

            agentBankCode: null,
            agentBankName: null,
            agentBankShortName: null,
            agentBankAccountNumber: null,
            agentBankAccountName: null,

            leasingCode: null,
            leasingName: null,
            poCode: "",
            contractNumber: "",
            productPrice: 0,
            disbursedAmount: 0,
            tenor: 0,
            installmentAmount: 0,
            fincoCommission: 0,
            agentCommission: 0,
            salesCommission: 0,
            spvCommission: 0,

            vehicleYear: null,
            filterVehicleCategory: null,
            filterVehicleBrandUuid: null,
            filterVehicleBrandName: null,
            filterVehicleModelUuid: null,
            filterVehicleModelName: null,
        }
        this.state = {...this.initState}
    }

    async componentDidMount() {
        await this.showOfferDetail();
    }

    async componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (this.props.offerCode !== prevProps.offerCode || this.props.time !== prevProps.time) {
            await this.showOfferDetail();
        }
    }

    showOfferDetail = async () => {
        await this.promisedSetState({offerCode: "", dataDetailOffer: {}, fetchingDetailOffer: true, updateProcess: false, showFetchPoResult: false, dataPo: {}});
        const sleep = (waitTimeInMs: number) => new Promise(resolve => setTimeout(resolve, waitTimeInMs));
        await sleep(100);

        await offerGeneralApiService.getDetailOffer({companyCode: this.props.companyCode, offerCode: this.props.offerCode}).then(async value => {
            await this.promisedSetState({
                dataDetailOffer: value.data.data,
                offerCode: value.data.data?.transaction_code,
                purchaseMethod: value.data.data?.purchase_method,
                offerStatus: value.data.data?.offer_status,

                transactionType: value.data.data?.transaction_type,
                documentOwnershipType: value.data.data?.document_ownership_type,

                leasingCode: value.data.data?.credit?.finco_code,
                leasingName: value.data.data?.credit?.finco_name,
                poCode: (value?.data?.data?.credit?.po_code?.toUpperCase() !== "NONE") ? value?.data?.data?.credit?.po_code?.toUpperCase() : "",
                contractNumber: value?.data?.data?.credit?.contract_number?.toUpperCase(),
                productPrice: value?.data?.data?.product?.price,
                disbursedAmount: value?.data?.data?.credit?.disbursed_amount,
                tenor: value?.data?.data?.credit?.tenor,
                installmentAmount: value?.data?.data?.credit?.installment_amount,
                fincoCommission: value?.data?.data?.credit?.finco_commission,
                agentCommission: value?.data?.data?.credit?.agent_commission,
                salesCommission: value?.data?.data?.credit?.sales_commission,
                spvCommission: value?.data?.data?.credit?.spv_commission,

                customerBankCode: value?.data?.data?.bank_account?.bank_code || null,
                customerBankAccountNumber: value?.data?.data?.bank_account?.account_number || null,
                customerBankAccountName: value?.data?.data?.bank_account?.account_name || null,
                customerBankName: value?.data?.data?.bank_account?.bank_name || null,
                customerBankShortName: value?.data?.data?.bank_account?.bank_short_name || null,

                agentBankCode: value?.data?.data?.agent_bank_account?.bank_code || null,
                agentBankAccountNumber: value?.data?.data?.agent_bank_account?.account_number || null,
                agentBankAccountName: value?.data?.data?.agent_bank_account?.account_name || null,
                agentBankName: value?.data?.data?.agent_bank_account?.bank_name || null,
                agentBankShortName: value?.data?.data?.agent_bank_account?.bank_short_name || null,

                filterVehicleCategory: value?.data?.data?.product?.category?.toLowerCase() || null,
                filterVehicleBrandUuid: value?.data?.data?.product?.brand_uuid || null,
                filterVehicleModelUuid: value?.data?.data?.product?.model_uuid || null,
                filterVehicleBrandName: value?.data?.data?.product?.brand_name || null,
                filterVehicleModelName: value?.data?.data?.product?.model_name || null,
                vehicleYear: value?.data?.data?.product?.year || null,
            });
            // await sleep(1000);
            await this.promisedSetState({fetchingDetailOffer: false,});
        }).catch(async reason => {
            await this.promisedSetState({
                dataDetailOffer: {},
                fetchingDetailOffer: false,
            });
        });
    }


    onFieldChange = <T extends keyof Pick<any, "transactionType" | "documentOwnershipType" | "agentBankAccountNumber" | "agentBankAccountName" | "vehicleYear" | "filterVehicleCategory" | "customerBankAccountNumber" | "customerBankAccountName" | "poCode" | "contractNumber" | "productPrice" | "disbursedAmount" | "tenor" | "installmentAmount" | "fincoCommission" | "agentCommission" | "salesCommission" | "spvCommission">>(target: T, value: any) => {
        const currentState = {...this.state};
        switch (target) {
            case "documentOwnershipType":
                currentState.documentOwnershipType = value;
                break;
            case "transactionType":
                currentState.transactionType = value;
                break;
            case "vehicleYear":
                currentState.vehicleYear = value;
                break;
            case "filterVehicleCategory":
                currentState.filterVehicleCategory = value
                currentState.filterVehicleBrandUuid = null
                currentState.filterVehicleModelUuid = null
                currentState.filterVehicleBrandName = null
                currentState.filterVehicleModelName = null
                break
            case "agentBankAccountNumber":
                currentState.agentBankAccountNumber = value;
                break;
            case "agentBankAccountName":
                currentState.agentBankAccountName = value;
                break;
            case "customerBankAccountNumber":
                currentState.customerBankAccountNumber = value;
                break;
            case "customerBankAccountName":
                currentState.customerBankAccountName = value;
                break;
            case "productPrice":
                currentState.productPrice = value;
                break;
            case "disbursedAmount":
                currentState.disbursedAmount = value;
                break;
            case "installmentAmount":
                currentState.installmentAmount = value;
                break;
            case "tenor":
                currentState.tenor = value;
                break;
            case "poCode":
                currentState.poCode = value;
                break;
            case "contractNumber":
                currentState.contractNumber = value;
                break;
            case "fincoCommission":
                currentState.fincoCommission = value;
                break;
            case "agentCommission":
                currentState.agentCommission = value;
                break;
            case "salesCommission":
                currentState.salesCommission = value;
                break;
            case "spvCommission":
                currentState.spvCommission = value;
                break;
        }
        this.setState({...currentState});
    }

    onUpdateData = async () => {
        await this.promisedSetState({updateProcess: true});
        const dataUpdate = {
            update_type: "purchase-update",
            company: this.props.companyCode,
            admin_id: this.user,
            admin_name: this.user,
            offer_code: this.state.offerCode,

            transaction_type: this.state.transactionType,
            document_ownership_type: this.state.documentOwnershipType,

            finco_code: this.state.leasingCode,
            finco_name: this.state.leasingName,
            po_code: this.state.poCode,
            contract_number: this.state.contractNumber,

            product_price: this.state.productPrice,
            disbursed_amount: this.state.disbursedAmount,
            tenor: this.state.tenor,
            installment_amount: this.state.installmentAmount,
            finco_commission: this.state.fincoCommission,
            agent_commission: this.state.agentCommission,
            sales_commission: this.state.salesCommission,
            spv_commission: this.state.spvCommission,

            bank_code: this.state.customerBankCode,
            bank_name: this.state.customerBankName,
            bank_short_name: this.state.customerBankShortName,
            account_number: this.state.customerBankAccountNumber,
            account_name: this.state.customerBankAccountName,

            agent_bank_code: this.state.agentBankCode,
            agent_bank_name: this.state.agentBankName,
            agent_bank_short_name: this.state.agentBankShortName,
            agent_account_number: this.state.agentBankAccountNumber,
            agent_account_name: this.state.agentBankAccountName,

            category: this.state.filterVehicleCategory,
            brand_name: this.state.filterVehicleBrandName,
            brand_uuid: this.state.filterVehicleBrandUuid,
            model_name: this.state.filterVehicleModelName,
            model_uuid: this.state.filterVehicleModelUuid,
            yaer: this.state.vehicleYear,
        };

        try {
            await offerGeneralApiService.updateOffer(dataUpdate).then(successData => {
                Modal.success({title: 'Proses Sukses', content: 'Offer berhasil di update '});
                this.setState({updateProcess: false,});
                this.props.onCloseUpdateVehicleAndPromo("close");
            });
        } catch (e) {
            Modal.error({title: 'Proses Gagal', content: 'Server Menolak Inputan Anda :' + e});
            await this.promisedSetState({updateProcess: false});
        }
    }

    onBankChangeCustomer = (data: any) => {
        this.setState({
            customerBankCode: data.value?.toUpperCase(),
            customerBankName: data.name,
            customerBankShortName: data.short_name,
        });
    }

    onBankChangeAgent = (data: any) => {
        this.setState({
            agentBankCode: data.value?.toUpperCase(),
            agentBankName: data.name,
            agentBankShortName: data.short_name,
        });
    }

    onVehicleBrandChange = (data: any) => {
        this.setState({
            filterVehicleBrandUuid: data?.key,
            filterVehicleBrandName: data?.children,
            filterVehicleModelUuid: null,
            filterVehicleModelName: null
        })
    }

    onVehicleModelChange = (data: any) => {
        this.setState({
            filterVehicleModelUuid: data.value,
            filterVehicleModelName: data?.children
        })
    }

    onLeasingChange = (data: any) => {
        this.setState({leasingCode: data.value?.toUpperCase(), leasingName: data.children?.toUpperCase()});
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        const currentYear: number = new Date().getFullYear();
        const years: number[] = Array.from({length: 20}, (_, index) => currentYear - index);
        const listPromoUsedName = [];
        for (const item of this.state.dataDetailOffer?.detail_promo ?? []) {
            listPromoUsedName.push(item?.code);
        }

        return (
            <React.Fragment>
                <div style={this.state.fetchingDetailOffer ? {} : {display: 'none'}} className={`spinCenter`}>
                    <Spin size="large"/>
                </div>

                <div style={!this.state.fetchingDetailOffer && !this.state.purchaseMethod ? {} : {display: 'none'}} className={`spinCenter`}>
                    Offer Code Not Found
                </div>

                <div style={!this.state.fetchingDetailOffer && this.state.purchaseMethod && this.state.offerStatus !== "OPEN" ? {} : {display: 'none'}}>
                    Offer not in OPEN Condition
                </div>

                <div style={!this.state.fetchingDetailOffer && this.state.purchaseMethod && this.state.offerStatus === "OPEN" ? {} : {display: 'none'}}>
                    <Row>
                        <Col xs={24} xl={24}>
                            <Card style={{margin: 3}} size="small" title="Data Sebelum Diubah">
                                <Row>
                                    <Col xs={24} xl={8} style={{fontSize: "90%"}}>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Kode Offer:</Col><Col xs={24} xl={16}>{this.state.offerCode}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Tanggal Offer:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.transaction_time?.substring(0, 10)}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Kode Agen:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.agent_code}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Kode Promo:</Col><Col xs={24} xl={16}>{listPromoUsedName.toString()}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Kode PO:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.credit?.po_code?.toUpperCase()}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Nomor Kontrak:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.credit?.contract_number?.toUpperCase()}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Finco:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.credit?.finco_code?.toUpperCase()} - {this.state.dataDetailOffer?.credit?.finco_name}</Col></Row>
                                    </Col>
                                    <Col xs={24} xl={8} style={{fontSize: "90%"}}>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Nomor Polisi:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.product?.serial_number}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Brand:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.product?.brand_name}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Model:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.product?.model_name}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Variant:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.product?.variant_code} {this.state.dataDetailOffer?.product?.variant_name}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Warna:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.product?.color_name}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Tahun Kendaraan:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.product?.year}</Col></Row>
                                    </Col>
                                    <Col xs={24} xl={8} style={this.state.purchaseMethod === 'credit' ? {fontSize: "90%"} : {display: 'none'}}>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Nilai Produk:</Col><Col xs={24} xl={16}>{currencyFormat(this.state.dataDetailOffer?.product?.price)}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Nilai Pendanaan:</Col><Col xs={24} xl={16}>{currencyFormat(this.state.dataDetailOffer?.credit?.disbursed_amount)}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Tenor:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.credit?.tenor} @ {currencyFormat(this.state.dataDetailOffer?.credit?.installment_amount)}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Komisi Finco:</Col><Col xs={24} xl={16}>{currencyFormat(this.state.dataDetailOffer?.credit?.finco_commission)}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Komisi Agent (Amarta VIP-agent):</Col><Col xs={24} xl={16}>{currencyFormat(this.state.dataDetailOffer?.credit?.agent_commission || 0)}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Komisi Sales:</Col><Col xs={24} xl={16}>{currencyFormat(this.state.dataDetailOffer?.credit?.sales_commission || 0)}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Komisi SPV:</Col><Col xs={24} xl={16}>{currencyFormat(this.state.dataDetailOffer?.credit?.spv_commission || 0)}</Col></Row>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={24} xl={24} className={`pad-10`} style={this.state.purchaseMethod === 'credit' ? {} : {display: 'none'}}>
                            <Row>
                                <Col xs={24} xl={8} style={{fontSize: "90%", padding: 10}}>
                                    <Divider orientation="left" plain><i>Data Kendaraan</i></Divider>
                                    <div className={`mt-5`}>
                                        <i className={`small-text-grey`}><b className={`required`}>*</b> Category</i><br/>
                                        <Select showSearch placeholder="Pilih Kategori Kendaraan" optionFilterProp="children" onChange={value => this.onFieldChange("filterVehicleCategory", value)} value={this.state.filterVehicleCategory} style={{width: "100%"}}>
                                            <Select.Option key={`car`} value={`car`}>{`Mobil`}</Select.Option>
                                            <Select.Option key={`motorcycle`} value={`motorcycle`}>{`Motor`}</Select.Option>
                                        </Select>
                                    </div>
                                    <div className={`mt-5`}>
                                        <i className={`small-text-grey`}><b className={`required`}>*</b> Merk Kendaraan</i><br/>
                                        <VehicleBrandSelect value={this.state.filterVehicleBrandUuid} onVehicleBrandChangeProps={this.onVehicleBrandChange} category={this.state.filterVehicleCategory} time={Math.floor(+new Date() / 1000)}/>
                                    </div>
                                    <div className={`mt-5`}>
                                        <i className={`small-text-grey`}><b className={`required`}>*</b> Model Kendaraan</i><br/>
                                        <VehicleModelSelect value={this.state.filterVehicleModelUuid} onVehicleModelChangeProps={this.onVehicleModelChange} brandCode={this.state.filterVehicleBrandUuid} category={this.state.filterVehicleCategory} time={Math.floor(+new Date() / 1000)}/>
                                    </div>
                                    <div className={`mt-5`}>
                                        <i className={`small-text-grey`}><b className={`required`}>*</b> Tahun Kendaraan</i><br/>
                                        <Select
                                            showSearch
                                            style={{width: "100%"}}
                                            placeholder="Pilih Tahun"
                                            optionFilterProp="children"
                                            onChange={value => this.onFieldChange("vehicleYear", value.toString())}
                                            value={this.state.vehicleYear}
                                        >
                                            {years.map((year) => (
                                                <Select.Option key={year} value={year}>
                                                    {year}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </div>
                                    <Divider style={{marginTop: 23}} orientation="left" plain><i>Data Leasing</i></Divider>
                                    <div className={`mt-5`}>
                                        <i className={`small-text-grey`}><b className={`required`}>*</b> Tipe Kepemilikan</i>
                                        <Tooltip
                                            title={
                                                <>
                                                    Segaris = Nama STNK dan KTP sama <br/>
                                                    Tidak Segaris = Nama STNK dan KTP berbeda, namun ada dalam KK <br/>
                                                </>
                                            }
                                            color={'cyan'}
                                        >
                                            <InfoCircleOutlined
                                                style={{fontSize: "80%", marginLeft: 5, color: "#3656f4", cursor: "help"}}
                                            />
                                        </Tooltip>
                                        <br/>
                                        <Select showSearch placeholder="Pilih Tipe Kepemilikan" optionFilterProp="children" onChange={value => this.onFieldChange("documentOwnershipType", value)} value={this.state.documentOwnershipType} style={{width: "100%"}}>
                                            <Select.Option value={`PERSONAL`}>{`Segaris`}</Select.Option>
                                            <Select.Option value={`SPOUSE`}>{`Tidak Segaris`}</Select.Option>
                                            <Select.Option value={`OTHER`}>{`Diluar Kartu Keluarga`}</Select.Option>
                                        </Select>
                                    </div>
                                    <div className={`mt-5`}>
                                        <i className={`small-text-grey`}><b className={`required`}>*</b> Jenis Order</i><br/>
                                        <Select showSearch placeholder="Pilih Jenis Order" optionFilterProp="children" onChange={value => this.onFieldChange("transactionType", value)} value={this.state.transactionType} style={{width: "100%"}}>
                                            <Select.Option value={`new-loan`}>{`Pinjaman Baru / New Loan`}</Select.Option>
                                            <Select.Option value={`take-over`}>{`Take Over`}</Select.Option>
                                            <Select.Option value={`top-up`}>{`Top Up`}</Select.Option>
                                        </Select>
                                    </div>
                                    <div className={`mt-5`}>
                                        <i className={`small-text-grey`}><b className={`required`}>*</b> Kode Finco (Leasing)</i><br/>
                                        <SelectLeasing onSupplierChangeProps={this.onLeasingChange} value={this.state.leasingCode}/>
                                    </div>
                                    <div className={`mt-5`}>
                                        <i className={`small-text-grey`}><b className={`required`}>*</b> Kode PO</i><br/>
                                        <Input value={this.state.poCode} placeholder="Kode PO" onChange={event => this.onFieldChange("poCode", event.target.value)}/>
                                    </div>
                                    <div className={`mt-5`}>
                                        <i className={`small-text-grey`}>Nomor Kontrak</i><br/>
                                        <Input value={this.state.contractNumber} placeholder="Nomor Kontrak" onChange={event => this.onFieldChange("contractNumber", event.target.value)}/>
                                    </div>
                                </Col>
                                <Col xs={24} xl={8} style={{fontSize: "90%", padding: 10}}>
                                    <Divider orientation="left" plain><i>Data Rekening Konsumen</i></Divider>
                                    <div className={`mt-5`}>
                                        <i className={`small-text-grey`}>Bank Pemilik</i><br/>
                                        <BankSelect onBankChangeProps={this.onBankChangeCustomer} value={this.state.customerBankCode}/>
                                    </div>
                                    <div className={`mt-5`}>
                                        <i className={`small-text-grey`}>Nomor Rekening Pemilik</i><br/>
                                        <Input value={this.state.customerBankAccountNumber} placeholder="Nomor Rekening Pemilik" onChange={event => this.onFieldChange("customerBankAccountNumber", event.target.value)}/>
                                    </div>
                                    <div className={`mt-5`}>
                                        <i className={`small-text-grey`}>Nama Rekening Pemilik</i><br/>
                                        <Input value={this.state.customerBankAccountName} placeholder="Nama Rekening Pemilik" onChange={event => this.onFieldChange("customerBankAccountName", event.target.value)}/>
                                    </div>

                                    <Divider style={{marginTop: 23}} orientation="left" plain><i>Data Rekening Agent (Mediator)</i></Divider>
                                    <div className={`mt-5`}>
                                        <i className={`small-text-grey`}><b className={`required`}>*</b> Bank Agent</i><br/>
                                        <BankSelect onBankChangeProps={this.onBankChangeAgent} value={this.state.agentBankCode}/>
                                    </div>
                                    <div className={`mt-5`}>
                                        <i className={`small-text-grey`}><b className={`required`}>*</b> Nomor Rekening Agent</i><br/>
                                        <Input value={this.state.agentBankAccountNumber} placeholder="Nomor Rekening Agent" onChange={event => this.onFieldChange("agentBankAccountNumber", event.target.value)}/>
                                    </div>
                                    <div className={`mt-5`}>
                                        <i className={`small-text-grey`}><b className={`required`}>*</b> Nama Rekening Agent</i><br/>
                                        <Input value={this.state.agentBankAccountName} placeholder="Nama Rekening Agent" onChange={event => this.onFieldChange("agentBankAccountName", event.target.value)}/>
                                    </div>


                                </Col>
                                <Col xs={24} xl={8} style={{fontSize: "90%", padding: 10}}>
                                    <Divider orientation="left" plain><i>Data Credit & Komisi</i></Divider>
                                    <div className={`mt-5`}>
                                        <i className={`small-text-grey`}>Nilai Produk (Nilai Taksir)</i><br/>
                                        <CurrencyInput className={'ant-input'} value={this.state.productPrice} onValueChange={value => this.onFieldChange("productPrice", value ? parseFloat(value) : 0)}/>
                                    </div>
                                    <div className={`mt-5`}>
                                        <i className={`small-text-grey`}><b className={`required`}>*</b> Nilai Pendanaan</i><br/>
                                        <CurrencyInput className={'ant-input'} value={this.state.disbursedAmount} onValueChange={value => this.onFieldChange("disbursedAmount", value ? parseFloat(value) : 0)}/>
                                    </div>
                                    <div className={`mt-5`}>
                                        <i className={`small-text-grey`}><b className={`required`}>*</b> Tenor</i><br/>
                                        <CurrencyInput className={'ant-input'} value={this.state.tenor} onValueChange={value => this.onFieldChange("tenor", value ? parseFloat(value) : 0)}/>
                                    </div>
                                    <div className={`mt-5`}>
                                        <i className={`small-text-grey`}>Cicilan</i><br/>
                                        <CurrencyInput className={'ant-input'} value={this.state.installmentAmount} onValueChange={value => this.onFieldChange("installmentAmount", value ? parseFloat(value) : 0)}/>
                                    </div>
                                    <div className={`mt-5`} style={{display: "none"}}>
                                        <i className={`small-text-grey`}><b className={`required`}>*</b> Komisi Finco</i><br/>
                                        <CurrencyInput className={'ant-input'} value={this.state.fincoCommission} onValueChange={value => this.onFieldChange("fincoCommission", value ? parseFloat(value) : 0)}/>
                                    </div>
                                    <div className={`mt-5`} style={{display: "none"}}>
                                        <i className={`small-text-grey`}><b className={`required`}>*</b> Komisi Agent (Mediator)</i><br/>
                                        <CurrencyInput className={'ant-input'} value={this.state.agentCommission} onValueChange={value => this.onFieldChange("agentCommission", value ? parseFloat(value) : 0)}/>
                                    </div>
                                    <div className={`mt-5`}>
                                        <i className={`small-text-grey`}>Komisi Sales (Amarta VIP-agent)</i><br/>
                                        <CurrencyInput className={'ant-input'} value={this.state.salesCommission} onValueChange={value => this.onFieldChange("salesCommission", value ? parseFloat(value) : 0)}/>
                                    </div>
                                    <div className={`mt-5`}>
                                        <i className={`small-text-grey`}>Komisi SPV</i><br/>
                                        <CurrencyInput className={'ant-input'} value={this.state.spvCommission} onValueChange={value => this.onFieldChange("spvCommission", value ? parseFloat(value) : 0)}/>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <br/>
                    <i style={{fontSize: '85%', color: "darkred"}}>*mohon lakukan croscheck, dengan melihat detail offer setelah proses update selesai.</i><br/><br/>
                    <Button type={"primary"} loading={this.state.updateProcess} onClick={() => this.onUpdateData()}> Update Data</Button>
                </div>
            </React.Fragment>
        )
    }
}

export default UpdateGeneralOffer;